<template>
  <div v-if="loadSuccess" id="cert_application_outer" :class="[ isVip ? 'shba-vips-border-color' : 'shba-no-vips-border-color']">
    <div style="position: relative;margin-top: 30px;">
      <el-steps id="cert_top_steps" :active="stepIndex" finish-status="success" align-center>
        <el-step v-for="(item, index) in stepList" :key="'step_item_' + index" :title="item" />
      </el-steps>

<!--      <div style="position:absolute;left: 0;top: 0;width: 100px;height: 20px;background-color: red;"></div>-->

    </div>

    <div style="margin-top: 30px; min-height: 150px" >
      <informations-view v-if="stepIndex == 0" :judge="judgeData" v-on:informationSubmitSuccess="informationSubmitSuccess"/>
      <id-verification-view v-else-if="stepIndex == 1" :judge="judgeData" v-on:nextStepClick="gotoPayView" v-on:realNameVerifySuccess="realNameSuccess" v-on:backToEditPage="gotoEditiView"/>
      <payment-view v-else-if="stepIndex == 2" v-on:paySuccess="dealWithPaySuccess" :judge="judgeData"/>
      <official-check-view v-else-if="stepIndex == 3" :judge="judgeData" v-on:backToEditPage="gotoEditiView"/>
      <offline-check-view v-else-if="stepIndex == 4" :judge="judgeData" />
      <success-view v-else :judge="judgeData" />
    </div>

    <cert-application-submit-data-preview v-if="showDataPreview"
                                          v-bind:judge="judgeData"
                                          v-on:close="showDataPreview=false" />


  </div>
</template>

<script>

import CertApplicationInforsSubmitVue from "../components/certificates/application/CertApplicationInforsSubmitVue";
import CertApplicationIDVerificationVue from "../components/certificates/application/CertApplicationIDVerificationVue";
import CertApplicationCostPayVue from "../components/certificates/application/CertApplicationCostPayVue";
import CertApplicationOfficialCheckVue from "../components/certificates/application/CertApplicationOfficialCheckVue";
import CertApplicationOfflineCheckVue from "../components/certificates/application/CertApplicationOfflineCheckVue";
import CertApplicationSuccessVue from "../components/certificates/application/CertApplicationSuccessVue";
import CertApplicationSubmitDataPreview from "../components/certificates/application/CertApplicationSubmitDataPreview";
import EventManager from '../js/event-common';

export default {
  name: "ProfessionalCertApplication",
  components: {
    InformationsView: CertApplicationInforsSubmitVue,
    IdVerificationView: CertApplicationIDVerificationVue,
    PaymentView: CertApplicationCostPayVue,
    OfficialCheckView: CertApplicationOfficialCheckVue,
    OfflineCheckView: CertApplicationOfflineCheckVue,
    SuccessView: CertApplicationSuccessVue,
    CertApplicationSubmitDataPreview,
  },
  data() {
    return {
      currentId: null,
      stepIndex: 0,
      stepList: [
        '填写认证信息',
        '实名认证',
        '支付认证费',
        '协会审核',
        '线下考核',
      ],
      loadSuccess: false,
      judgeData: null,
      isEdit: true,
      updateJudgeList: false,
      timeOutFlag: null,
      showDataPreview: false,
    }
  },
  computed: {
    myEventManager() {
      return this.$store.state.eventManager;
    },
    httpManager() {
      return this.$store.state.http;
    },
    certId() {
      return this.$route.params.certId
    },
    user() {
      return this.$store.state.user;
    },
    isVip() {
      if (this.user == null) {
        return false;
      }
      let user = this.user;
      let memberValidDate = user.memberValidDate;
      if (memberValidDate == null) {
        return false;
      }
      return this.$moment(memberValidDate).add('1','days').add('-1', 'seconds').isAfter(this.$moment());
    },
  },

  mounted() {
    this.currentId = this.certId;
    this.dealWithCurrentId();
    this.configureClickView();
  },
  watch: {
    $route: {
      handler(val, oldVal) {
        if (val == oldVal) {
          return;
        }
        let certId = val.params.certId;
        if (this.currentId != certId) {
          this.currentId = certId;
          this.dealWithCurrentId();
        }
      },
      deep: true
    }
  },
  destroyed() {
    this.clearTimeFlag();
  },

  methods: {
    configureClickView() {
      let _this = this;
      let stepView = $("#cert_application_outer #cert_top_steps .el-step:first-child");
      let width = stepView.width();
      let height = stepView.height();
      if (width == undefined || height == null) {
        setTimeout(function () {
          _this.configureClickView();
        }, 50);
        return;
      }

      let root = $("#cert_application_outer > div:first-child");
      let clickView = $("<a href='javascript:void(0)'></a>");
      clickView.width(width);
      clickView.height(height);
      clickView.css('position', 'absolute');
      clickView.css('left', 0);
      clickView.css('top', 0);
      clickView.css('z-index', 99);
      clickView.click(function () {
        _this.stepClicked();
      });
      root.append(clickView);
    },

    stepClicked() {
      if (this.judgeData == null) {
        return;
      }
      this.showDataPreview = true;
    },

    clearTimeFlag() {
      if (this.timeOutFlag != null) {
        clearTimeout(this.timeOutFlag);
        this.timeOutFlag = null;
      }
    },

    dealWithCurrentId() {
      if (this.currentId != 0) {
        this.loadSuccess = false;
        this.loadData();
      } else {
        this.judgeData = null;
        this.stepIndex = 0;
        this.loadSuccess = true;
      }
    },
    loadData() {
      let certId = this.currentId;
      let _this = this;
      this.httpManager.ajax.getJudgeDetailData(certId, function (data) {
        let code = data.code;
        // console.log(data.data);
        if (code == 0) {
          _this.judgeData = data.data;
          _this.dealWithJudgeData();
          _this.loadSuccess = true;
        } else {
          _this.$toast('数据加载失败！');
        }
      }, function (data) {
        _this.$toast('数据加载失败，请刷新！');
      });
    },
    dealWithJudgeData() {
      let judge = this.judgeData;
      let status = judge.status;
      let staminaTest = judge.staminaTest;
      if (staminaTest == null) {
        staminaTest = '未进行';
      }
      let theoryTest = judge.theoryTest;
      if (theoryTest == null) {
        theoryTest = '未进行';
      }

      let auditStatus = judge.auditStatus;
      if (auditStatus == 0) {
        this.stepIndex = 0;
        return;
      }

      let bothTrue = false;
      if (staminaTest == '已通过' && theoryTest == '已通过') {
        bothTrue = true;
      }
      if (status == 6) {
        this.stepIndex = 0;
      } else if (status == 1 || status == 2) {
        this.stepIndex = 1;
      } else if (status == 3) {
        this.stepIndex = 2;
      } else if (status == 4 || status == 7 || status == 8) {
        this.stepIndex = 3;
      } else if (status == 5) {
        if (!bothTrue) {
          this.stepIndex = 4;
        } else {
          this.stepIndex = 5;
        }
      }

      let needsSetTimeOut = false;
      if ( status == 5 && (theoryTest == '未进行' || staminaTest == '未进行')) {
        needsSetTimeOut = true;
      }
      if (status == 4 || needsSetTimeOut) {
        let _this = this;
        this.timeOutFlag = setTimeout(function () {
          _this.timeOutFlag = null;
          _this.loadData();
        }, 20 * 1000);
      }
    },

    informationSubmitSuccess(params) {
      let id = params.id;
      let newParams = {
        certId: id
      };
      this.myEventManager.postNotification(EventManager.notificationNameObject.judgeApplicationSuccess, {});
      if (this.currentId != id) {
        this.currentId = id;
        this.$router.push({
          name: this.$route.name,
          params: newParams,
        });
      }
      this.dealWithCurrentId();
    },
    nextStepChanged(res) {
      let status = res.status;
      this.stepIndex = status;
    },
    realNameSuccess() {
      this.judgeData.status = 2;
    },
    gotoPayView() {
      this.judgeData.status = 3;
      this.stepIndex = 2;
      this.dealWithCurrentId();
    },
    dealWithPaySuccess(res) {
      let status = res.status;
      this.judgeData.status = status;
      if (status == 4) {
        this.stepIndex = 3;
      } else if (status == 5) {
        this.stepIndex = 4;
      }
    },
    gotoEditiView() {
      if (this.judgeData.status == 8) {
        this.stepIndex = 1;
      } else {
        this.stepIndex = 0;
      }
    }
  }
}
</script>

<style scoped>
  #cert_application_outer {
    margin-top: 30px;
    padding-left: 5px;
    padding-right: 5px;
    padding-bottom: 30px;
    position: relative;
  }

  #cert_top_steps {

  }

  #cert_top_steps /deep/ .el-step__title {
    font-size: 1rem;
    line-height: 1.5rem;
    margin-top: 15px;
  }

  #cert_top_steps /deep/ .el-step__head.is-success {
    color: #666;
    border-color: #666;
  }

  #cert_top_steps /deep/ .el-step__title.is-success {
    color: #666;
    font-weight: bold;
  }

  #cert_top_steps /deep/ .el-step__head.is-process {
    color: #fc1a34;
    border-color: #fc1a34;
  }

  #cert_top_steps /deep/ .el-step__title.is-process {
    color: #fc1a34;
  }

  #cert_top_steps /deep/ .el-step__line {
    background-color: transparent;
    border-color: transparent;
  }

  #cert_application_outer .step-first-click-view {
    position:absolute;
    left: 0;
    top: 0;
    /*width: 100px;*/
    /*height: 20px;*/
    z-index: 999;
    /*background-color: cyan;*/
  }

</style>



// WEBPACK FOOTER //
// src/pages/ProfessionalCertApplication.vue